import { createFileRoute } from "@tanstack/react-router";
import { Mail, MapPin, Clock, MessageCircle } from "lucide-react";

import { LegalPage, LegalSection, CONTACT_EMAIL } from "@/components/legal-page";

export const Route = createFileRoute("/contact")({
  component: ContactPage,
  head: () => ({
    meta: [
      { title: "Contact Us | Civil Campus Ambassador Program Bengaluru" },
      {
        name: "description",
        content:
          "Reach the Civil Engineering Campus Ambassador Program team in Bengaluru for application, commission, training or reward related questions.",
      },
      { property: "og:title", content: "Contact Us | Campus Ambassador Program" },
      {
        property: "og:description",
        content:
          "Email the program team for questions about applications, commission payouts, training or rewards.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
});

const details = [
  {
    icon: Mail,
    label: "Email",
    value: CONTACT_EMAIL,
    href: `mailto:${CONTACT_EMAIL}`,
  },
  {
    icon: MessageCircle,
    label: "Program support",
    value: "Application, training & commission queries",
  },
  {
    icon: MapPin,
    label: "Location",
    value: "Bengaluru, Karnataka, India",
  },
  {
    icon: Clock,
    label: "Response time",
    value: "Mon–Sat, within 24 working hours",
  },
];

function ContactPage() {
  return (
    <LegalPage
      title="Contact Us"
      updated="4 August 2026"
      intro="Questions about your application, commission payout, training schedule or rewards? Email the program team and we will get back to you."
    >
      <div className="grid gap-4 sm:grid-cols-2">
        {details.map((item) => (
          <div
            key={item.label}
            className="rounded-2xl border border-border/70 bg-card p-5 shadow-sm"
          >
            <item.icon className="h-5 w-5 text-primary" />
            <p className="mt-3 text-xs font-bold uppercase tracking-[0.14em] text-muted-foreground">
              {item.label}
            </p>
            {item.href ? (
              <a
                href={item.href}
                className="mt-1 block break-all text-sm font-semibold text-foreground hover:text-primary"
              >
                {item.value}
              </a>
            ) : (
              <p className="mt-1 text-sm font-semibold text-foreground">{item.value}</p>
            )}
          </div>
        ))}
      </div>

      <LegalSection heading="Before you write to us">
        <p>
          If you have already applied, mention your full name and college so we can find
          your application faster. For commission questions, include the month and the
          referral details of the sale.
        </p>
      </LegalSection>

      <div className="rounded-2xl bg-navy-soft p-6">
        <p className="text-sm font-semibold text-navy-foreground">
          Ready to join instead?
        </p>
        <a
          href="/#apply"
          className="mt-4 inline-flex items-center gap-2 rounded-xl bg-gold px-6 py-3 text-sm font-extrabold tracking-wide text-gold-foreground transition-all hover:-translate-y-0.5 hover:brightness-105"
        >
          APPLY NOW
        </a>
      </div>
    </LegalPage>
  );
}
